import React, { Fragment, useContext } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { SubCategoriesPropTypes } from '../../types/index';
import getLogoMakerBannerConfig from '../../config/logoMakerBannerConfig';
import { DynamicGigListings, ProFirstGigListings, Pagination, RecommendationsCarousels, SelectedFilters, NumberOfResults, SortBy, TopBarFilters, MobileFilters, NoResults } from '../common';
import NestedSubcategoryNav from '../common/floating_topbar/nested_subcategory_nav';
import StickyComponent from '../hoc/stickyComponent';
import NscTilesCarousel from '../common/nsc_tiles_carousel';
import TopFiltersCarousel from '../common/top_filters_carousel';
import SeoSubCategory from '../common/seo_sub_category';
import MachineTranslationButtonWrapper from '../common/machine_translation_button_wrapper';
import { DEFAULT_LOCALE } from '../../../../shared/constants';
import SeoMarkups from '../seo_markups';
import { AppContext } from '../context/listingsContext';
import Modalities from '../common/modalities/Modalities';
import { includesAds } from '../../utils';
import { getFilterTilesCarousel } from '../common/top_filters_carousel/utils';
import { shoudlShowTileCaoursel } from '../../abTestAllocations/navigationTilesSC/utils';
import Breadcrumbs from './breadcrumbs';
import SubcatHeader from './header';

import './index.scss';

const SubCategories = (props) => {
    const {
        pagination,
        sorting,
        displayData,
        appFilters,
        topBarSorting,
        loggedIn,
        baseUrl
    } = props;

    const {
        isTouch,
        listings: [listings],
        inUgcTranslationsRollout,
        showLMBannerInSubCPage,
        inNavigationTilesSCTest,
        inNscIconsMobileWeb,
        filter,
        categoryIds
    } = useContext(AppContext);

    const { proData, choiceModalities, context: { sessionLocale, abTestsProps }, showListViewCards } = listings;
    const { header, breadcrumbs, nestedSubCategoryName, categoryName, seo_data, cachedSlug } = displayData;
    const { topBar, subCategory, sideBar, active, activeFiltersQueryString } = appFilters;
    const hasFilters = sideBar.length > 0;
    const noGigs = !listings.gigs.length > 0 && !proData;
    const isNestedSubcategory = !!nestedSubCategoryName;
    const selectedSorting = topBarSorting.find((sort) => sort.selected) || topBarSorting[0];
    const { children } = subCategory;
    const nestedSubCategoryItems = children[0].children;
    const displayTranslationButton = sessionLocale !== DEFAULT_LOCALE && inUgcTranslationsRollout;
    const { inPromoteMTCtaExpCGroup } = abTestsProps;
    const shouldDisplayMobileFilters = isTouch && hasFilters;
    const { nestedSubCategoryId, subCategoryId } = categoryIds || {};
    const subCatFiltersCarousel = getFilterTilesCarousel(subCategory.id, nestedSubCategoryId);
    const listingsWithAds = includesAds(listings.gigs) || (!!proData && includesAds(proData.proGigs));
    const { logoMakerBanner, logoMakerBannerConfig } = getLogoMakerBannerConfig({
        shouldShowBanner: showLMBannerInSubCPage,
        isTouch,
        showListViewCards
    });
    const shouldDisplayNestedSubcategoryNav = !inNscIconsMobileWeb && isTouch && !isNestedSubcategory;
    const shouldDisplayNscTilesCarousel = !isNestedSubcategory && (inNscIconsMobileWeb || !isTouch);

    return (
        <div className={classNames('sub-categories-page', { 'top-filters': !isTouch })}>
            {!loggedIn && <SeoMarkups breadcrumbs={breadcrumbs.slice(1)} faqs={seo_data.faqs} baseUrl={baseUrl}/>}
            <div className="row">
                <header>
                    {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs.slice(0, breadcrumbs.length - 1)}/>}
                    <SubcatHeader data={{ ...header, categoryName, scName: subCategory.name }}/>
                </header>
                {shouldDisplayNestedSubcategoryNav &&
                    <NestedSubcategoryNav subCategory={subCategory}
                        isTouch={isTouch}
                        activeFiltersQueryString={activeFiltersQueryString}/>
                }
            </div>
            {shouldDisplayNscTilesCarousel &&
                <div className="row">
                    <NscTilesCarousel items={nestedSubCategoryItems}/>
                </div>
            }
            {shouldDisplayMobileFilters &&
                <>
                    <StickyComponent>
                        <MobileFilters activeFilters={active}
                            sorts={topBarSorting}
                            filters={sideBar}/>
                    </StickyComponent>
                    {displayTranslationButton &&
                    <MachineTranslationButtonWrapper gigsListings={[listings.gigs]}
                        showSeparator={false}/>
                    }
                </>
            }
            {shoudlShowTileCaoursel({ isTouch, subCatFiltersCarousel, subCategoryId, inNavigationTilesSCTest }) &&
            <div className="row">
                <TopFiltersCarousel topFiltersCarousel={subCatFiltersCarousel} subCategoryId={subCategoryId}/>
            </div>
            }
            {!isTouch &&
            <Fragment>
                <TopBarFilters filters={topBar}
                    selectedFilters={filter.selected}
                    activeFilters={filter.active}
                    subCategory={subCategory}
                    noGigs={noGigs}/>

                <div className="selected-filters-wrapper row">
                    <SelectedFilters selectedFilters={filter.selected}
                        activeFilters={filter.active}/>
                </div>

                {!noGigs && <div className="row top-secondary">
                    <div className={classNames('results-info', { 'flex-center': inPromoteMTCtaExpCGroup })}>
                        <NumberOfResults pagination={pagination} withAds={listingsWithAds}/>
                        {displayTranslationButton &&
                            <MachineTranslationButtonWrapper gigsListings={[listings.gigs]}
                                showSeparator/>}
                    </div>

                    <SortBy title={selectedSorting.alias}
                        data={topBarSorting}/>
                </div>}
            </Fragment>}
            { !_.isEmpty(choiceModalities) && !_.isEmpty(choiceModalities.buckets) &&
            <div className="row modalities-row">
                <Modalities listing={listings}/>
            </div>
            }
            <div className="row content-row">
                {noGigs && <NoResults/>}
                <div className="content">
                    {proData ?
                        <ProFirstGigListings listings={listings}/> :
                        <DynamicGigListings listings={listings}
                            bannerConfig={logoMakerBannerConfig}
                            banner={logoMakerBanner}/>
                    }
                </div>
            </div>

            {window && window.location && <Pagination pagination={pagination}/>}
            {(!isTouch && loggedIn) && <RecommendationsCarousels sorting={sorting} activeFilters={active} loggedIn={loggedIn}/>}
            {!loggedIn && <div className="row"><SeoSubCategory {...seo_data} cachedSlug={cachedSlug}/></div>}
        </div>
    );
};

SubCategories.propTypes = SubCategoriesPropTypes;

export default SubCategories;
